import React, { useState, useEffect } from 'react';
import PaymentTable from '../Payment/PaymentTable';
import FeeTable from '../Fee/FeeTable';
import { getPayments, getFees } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import { Button, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';

function History(props) {
    const [payments, setPayments] = useState([]);
    const [isLoadingPayments, setIsLoadingPayments] = useState(false);
    const [fees, setFees] = useState([]);
    const [isLoadingFees, setIsLoadingFees] = useState(false);
    const [activeTab, setActiveTab] = useState('payments');

    useEffect(() => {
        fetchPayments();
    }, []);

    useEffect(() => {
        fetchFees();
    }, [props.linkedAccounts])

    const fetchPayments = async () => {
        setIsLoadingPayments(true);

        try {
            const paymentsResult = await getPayments({ isUserPayments: true, takeAmount: -1 });
            setPayments(paymentsResult);
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsLoadingPayments(false);
        }
    };

    const fetchFees = async () => {
        setIsLoadingFees(true);

        try {
            if (props.linkedAccounts == null || props.linkedAccounts.length == 0) {
                setFees([]);
            } else {
                const feesResult = await getFees({ accountIDs: props.linkedAccounts.map(a => a.accountID), paid: 1 });
                setFees(feesResult);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            setIsLoadingFees(false);
        }
    };

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const paymentTableOptions = {
        fields: {
            success: true,
            type: true,
            details: true,
            amount: true,
            processingFee: true,
            total: true,
            transactionId: false,
            paidDate: true,
            actions: false
        },
        footer: {
            feePaymentTotal: false,
            paymentTotal: false
        },
        actions: {
            add: false,
            view: false,
            edit: false,
            receipt: false,
            delete: false
        },
        details: {
            accountNumber: true,
            account: true,
            identifier: true,
            amount: true
        }
    };

    let paymentsJSX = (<div>No Payments Found...</div>);
    if (isLoadingPayments) {
        paymentsJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
    } else {
        paymentsJSX = (<PaymentTable payments={payments} options={paymentTableOptions} />);
    }

    const feeTableOptions = {
        fields: {
            accountNumber: true,
            account: true,
            division: true,
            facility: true,
            identifier: true,
            description: true,
            amount: true,
            balance: true,
            dueDate: true,
            paidInFull: true,
            actions: false
        },
        footer: {
            amountTotal: false,
            balanceTotal: false
        },
        actions: {
            add: false,
            view: false,
            edit: false,
            delete: false,
            viewAccount: false
        }
    };

    let feesJSX = (<div>No Fees Found...</div>);
    if (isLoadingFees || props.isLoadingLinkedAccounts) {
        feesJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>)
    } else {
        feesJSX = (<FeeTable fees={fees} options={feeTableOptions} />);
    }

    return (
        <div id="history">
            <Row className="header-row">
                <Col>
                    <h1>History</h1>
                </Col>
            </Row>
            <Row className="tabs-row">
                <Col>
                    <Nav tabs>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'payments' })}
                                onClick={() => { toggle('payments'); }}>
                                Payments
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={classnames({ active: activeTab === 'fees' })}
                                onClick={() => { toggle('fees'); }}>
                                Past Fees
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Col>
            </Row>
            <Row className="tab-content-row">
                <Col>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="payments">
                            {paymentsJSX}
                        </TabPane>
                        <TabPane tabId="fees">
                            {feesJSX}
                        </TabPane>
                    </TabContent>
                </Col>
            </Row>
        </div>
    );
}

export default History;